module.exports = __webpack_public_path__ + "img/pgtoaprovado.62b0053d.svg";